<template>
    <div class="home-content binding-mobile-wrapper">
        <div class="hint-text" style="margin-top: 30px;">为了给您提供更好的服务，请绑定手机号：</div>
        <div class="binding-mobile-form">
            <div class="form-item">
                <div class="label">+86</div>
                <div class="input-wrapper">
                    <input class="input" v-model="mobileForm.mobile"  type="number" placeholder="请输入手机号码">
                </div>
            </div>
            <!--            <div class="form-item captcha">-->
            <!--                <div class="label">验证码</div>-->
            <!--                <div class="input-wrapper">-->
            <!--                    <input class="input" type="text" placeholder="请输入验证码">-->
            <!--                </div>-->
            <!--                <div class="get-captcha">获取验证码</div>-->
            <!--            </div>-->
        </div>
        <div class="submit-button-wrapper"><button class="submit-button" @click="handleBindMobile">提 交</button></div>
        <div class="button-skip-wrapper"><a href="javascript:void(0)" class="button-skip" @click="handleSkip">跳过</a></div>
    </div>
</template>

<script>
    import BindingMobile from "../BindingMobile";
    import {mapMutations, mapState} from 'vuex';
    export default {
        name: "BindingMobileHome",
        extends: BindingMobile,
        computed: {
            ...mapState([
                'members'
            ])
        },
        methods: {
            handleSkip() {
                this.setIgnoreMobile(true);
                if (this.members.length > 0) {
                    this.$router.replace('/home/index')
                } else {
                    this.$router.replace('/home/addMember')
                }
            },

            onBindSuccess() {
                if (this.members.length > 0) {
                    this.$router.replace('/home/index')
                } else {
                    this.$router.replace('/home/addMember')
                }
            },

            ...mapMutations([
                'setIgnoreMobile'
            ])
        }
    }
</script>